<template>
  <JobBadge badge-text="Internal" is-primary-color>
    <template #title>
      Internal Job Post
    </template>

    <template #text>
      Internal posts show only on your internal job board
    </template>
  </JobBadge>
</template>

<script>
import JobBadge from '@/components/editor/badge/JobBadge.vue';

export default {
  name: 'JobBadgeInternal',
  components: { JobBadge },
};
</script>
